export const SCENE_KEYS = {
  boot: 'Boot',
  preload: 'Preload',
  mainMenu: 'MainMenu',
  tutorial: 'Tutorial',
  level: 'Level',
  pauseOverlay: 'PauseOverlay',
  results: 'Results',
  settings: 'Settings',
} as const;

export const SCENE_SEQUENCE = [
  SCENE_KEYS.boot,
  SCENE_KEYS.preload,
  SCENE_KEYS.mainMenu,
  SCENE_KEYS.tutorial,
  SCENE_KEYS.level,
  SCENE_KEYS.pauseOverlay,
  SCENE_KEYS.results,
  SCENE_KEYS.settings,
] as const;

export type SceneKey = (typeof SCENE_SEQUENCE)[number];
